import React, {useEffect, useState, useContext, useRef} from "react";

import {TokenContext} from "../../Store";
import Button from "@mui/material/Button";

import MaterialTable from "@material-table/core";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ProjectService from "../../../services/ProjectService";
import DataobjectService from "../../../services/DataobjectService";
import LoadingIndicator from "../../../shared/LoadingIndicator";
import {trackPromise} from "react-promise-tracker";
import DataComponentEdit from "../Dataobjects/DataComponentEdit";
import UploadDialog from "../Dataobjects/UploadDialog";

import { header } from'../../../shared/headerStyle';

const BACK_HEIGHT = 37;
const TOOLBAR_HEIGHT = 74;
const PAGINATION_HEIGHT = 52;
const BORDER = 1;

const getColumnType = (data) =>
    data.realestateobjectType || data.administrativeobjectType || '';


function BimUserProjectObjects({userProject, setUserProject, projectGuid, realm, projectId}) {
    const [token] = useContext(TokenContext);
    const [dataObjects, setDataObjects] = useState([]);
    const [subDataObjects, setSubDataObjects] = useState([]);
    const [showSubList, setShowSubList] = useState(false);

    useEffect(() => {
        const load = async () => {
            try {
                const result = await trackPromise(
                    ProjectService.listprojectobjects(token, realm, projectId, projectGuid)
                );
                setDataObjects(result.data);
            } catch (e) {
                console.error('Fehler beim Laden der Projektobjekte:', e);
            }
        };
        load();
    }, [token, realm, projectId, projectGuid]);

    return (
        <>
            <LoadingIndicator/>
            {!showSubList ? (
                <ObjectList
                    userProject={userProject}
                    setUserProject={setUserProject}
                    dataObjects={dataObjects}
                    setDataObjects={setDataObjects}
                    setSubDataObject={setSubDataObjects}
                    setShowSubList={setShowSubList}
                    realm={realm}
                />
            ) : (
                <ObjectSubList
                    subDataObjects={subDataObjects}
                    setShowSubList={setShowSubList}
                    userProject={userProject}
                />
            )}
        </>
    );
}

function ObjectList({userProject, setUserProject, dataObjects, setSubDataObject, setShowSubList, realm}) {
    const tableRef = useRef();
    const title = `${userProject.name} - Zugeordnete Objekte`;
    const [token] = useContext(TokenContext);
    const [isLoading, setIsLoading] = useState(false);

    const tableHeight = (window.innerHeight - BACK_HEIGHT - TOOLBAR_HEIGHT - PAGINATION_HEIGHT - BORDER) / window.innerHeight * 100;

    const goBack = () => {
        setUserProject(null);
    };

    const handleRowClick = async (event, object) => {
        event.preventDefault();
        setIsLoading(true);
        try {
            let result;
            if (object.administrativeobjectTypeGuid) {
                result = await trackPromise(
                    DataobjectService.listadministrativeobjectstoadministrative(token, realm, object.guid)
                );
            } else if (object.realestateobjectTypeGuid) {
                result = userProject.realestateobjectLevelGuid
                    ? await trackPromise(
                        DataobjectService.listrealestateobjectstorealestateobjectwithtypelevel(token, realm, object.guid, userProject.realestateobjectLevelGuid)
                    )
                    : await trackPromise(
                        DataobjectService.listrealestateobjectstorealestateobject(token, realm, object.guid)
                    );
            }
            if (result) {
                setSubDataObject(result.data);
                setShowSubList(true);
            }
        } catch (e) {
            console.error('Fehler beim Laden der Unterobjekte:', e);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div onClick={goBack} className="backline">
                <Button style={{color: '#ffffff'}}><ChevronLeftIcon />Zurück</Button>
            </div>
            <LoadingIndicator />
            <MaterialTable
                tableRef={tableRef}
                title={title}
                columns={[
                    { title: 'Bezeichnung', field: 'name' },
                    { title: 'Nummer', field: 'number' },
                    { title: 'Kennzeichen', field: 'label' },
                    { title: 'Typ', field: 'type', render: (rowData) => getColumnType(rowData) },
                ]}
                data={dataObjects}
                options={{
                    headerStyle: header,
                    rowStyle: rowData => ({
                        backgroundColor: rowData.deactivated ? '#EEE' : '#FFF'
                    }),
                    pageSize: 10,
                    pageSizeOptions: [10, 20, 50, 100],
                    actionsColumnIndex: -1,
                    selection: false,
                    exportButton: true,
                    exportAllData: true,
                    maxBodyHeight: `${tableHeight}vh`,
                    minBodyHeight: `${tableHeight}vh`,
                }}
                isLoading={isLoading}
                localization={{
                    pagination: {
                        labelDisplayedRows: '{from}-{to} von {count}',
                        labelRowsSelect: 'Zeilen',
                        labelRowsPerPage: 'Zeilen pro Seite'
                    },
                    toolbar: {
                        nRowsSelected: '{0} Zeile(n) ausgewählt',
                        searchTooltip: 'Suchen',
                        searchPlaceholder: 'Suchbegriff eingeben'
                    },
                    header: {
                        actions: ''
                    },
                    body: {
                        emptyDataSourceMessage: 'Keine Einträge gefunden',
                        filterRow: {
                            filterTooltip: 'Filter'
                        }
                    }
                }}
                onRowClick={handleRowClick}
                actions={[
                    rowData => ({
                        icon: 'wysiwyg',
                        tooltip: 'Alle zugehörigen Objekte anzeigen',
                        onClick: (event, rowData) => handleRowClick(event, rowData)
                    }),
                ]}
            />
        </>
    );
}


function ObjectSubList({subDataObjects, setShowSubList, userProject}) {
    const tableRef = useRef();
    const title = `${userProject.name} - Objekt zur Bauteil-Erfassung auswählen`;

    const [dataObjectSelected, setDataObjectSelected] = useState([]);
    const [DataComponentEditDialogOpen, setDataComponentEditDialogOpen] = useState(false);
    const [DataComponentFormDialogOpen, setDataComponentFormDialogOpen] = useState(false);
    const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
    const [, setComponentSelected] = useState([]);

    const tableHeight = (window.innerHeight - BACK_HEIGHT - TOOLBAR_HEIGHT - PAGINATION_HEIGHT - BORDER) / window.innerHeight * 100;

    const goBack = () => {
        setShowSubList(false);
    };

    const handleUploadClick = (event, item) => {
        event.preventDefault();
        setDataObjectSelected(item);
        setDataComponentEditDialogOpen(false);
        setUploadDialogOpen(true);
    };

    const handleEditClick = async (event, rowData) => {
        event.preventDefault();
        setComponentSelected([]);
        setDataObjectSelected(rowData);
        setDataComponentEditDialogOpen(true);
    };

    return (
        <>
            <div onClick={goBack} className="backline">
                <Button style={{color: '#ffffff'}}><ChevronLeftIcon />Zurück</Button>
            </div>
            <MaterialTable
                tableRef={tableRef}
                title={title}
                columns={[
                    { title: 'Bezeichnung', field: 'name' },
                    { title: 'Nummer', field: 'number' },
                    { title: 'Kennzeichen', field: 'label' },
                    { title: 'Typ', field: 'type' },
                ]}
                data={subDataObjects}
                options={{
                    headerStyle: header,
                    rowStyle: rowData => ({
                        backgroundColor: rowData.deactivated ? '#EEE' : '#FFF'
                    }),
                    pageSize: 10,
                    pageSizeOptions: [10, 20, 50, 100],
                    actionsColumnIndex: -1,
                    selection: false,
                    exportButton: true,
                    exportAllData: true,
                    filtering: true,
                    maxBodyHeight: `${tableHeight}vh`,
                    minBodyHeight: `${tableHeight}vh`,
                }}
                localization={{
                    pagination: {
                        labelDisplayedRows: '{from}-{to} von {count}',
                        labelRowsSelect: 'Zeilen',
                        labelRowsPerPage: 'Zeilen pro Seite'
                    },
                    toolbar: {
                        nRowsSelected: '{0} Zeile(n) ausgewählt',
                        searchTooltip: 'Suchen',
                        searchPlaceholder: 'Suchbegriff eingeben'
                    },
                    header: {
                        actions: ''
                    },
                    body: {
                        emptyDataSourceMessage: 'Keine Einträge gefunden',
                        filterRow: {
                            filterTooltip: 'Filter'
                        }
                    }
                }}
                onRowClick={(event, rowData) => handleEditClick(event, rowData)}
                actions={[]}
            />
            <DataComponentEdit
                dataObjectSelected={dataObjectSelected}
                setDataComponentEditDialogOpen={setDataComponentEditDialogOpen}
                DataComponentEditDialogOpen={DataComponentEditDialogOpen}
                handleUploadClick={handleUploadClick}
                setDataComponentFormDialogOpen={setDataComponentFormDialogOpen}
                DataComponentFormDialogOpen={DataComponentFormDialogOpen}
                userProject={userProject}
            />
            <UploadDialog
                dataObjectSelected={dataObjectSelected}
                setUploadDialogOpen={setUploadDialogOpen}
                uploadDialogOpen={uploadDialogOpen}
            />
        </>
    );
}

export default BimUserProjectObjects;
